import { render } from "./commonInfo.vue?vue&type=template&id=3d1ab1f3"
import script from "./commonInfo.vue?vue&type=script&lang=js"
export * from "./commonInfo.vue?vue&type=script&lang=js"

import "./commonInfo.vue?vue&type=style&index=0&id=3d1ab1f3&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__